import { useMemo, useState } from 'react';

function buildCandidates({ url, faviconUrl }) {
  const candidates = [];
  if (faviconUrl) candidates.push(faviconUrl);

  if (url) {
    try {
      const u = new URL(url);
      const origin = u.origin;
      const host = u.host;
      candidates.push(`${origin}/favicon.ico`);
      if (u.protocol === 'https:') {
        candidates.push(`http://${host}/favicon.ico`);
      } else if (u.protocol === 'http:') {
        candidates.push(`https://${host}/favicon.ico`);
      }
      candidates.push(`https://icons.duckduckgo.com/ip3/${encodeURIComponent(host)}.ico`);
      candidates.push(`https://www.google.com/s2/favicons?sz=64&domain_url=${encodeURIComponent(`https://${host}`)}`);
    } catch {
      // ignore
    }
  }

  return Array.from(new Set(candidates.filter(Boolean)));
}

export default function Favicon({ url, faviconUrl, className = 'SiteIcon', alt = '' }) {
  const candidates = useMemo(() => buildCandidates({ url, faviconUrl }), [url, faviconUrl]);
  const [index, setIndex] = useState(0);

  if (!candidates.length) return null;
  const src = candidates[index];

  return (
    <img
      className={className}
      alt={alt}
      src={src}
      loading="lazy"
      onError={() => setIndex((i) => (i + 1 < candidates.length ? i + 1 : i))}
    />
  );
}
